export const STAFF_ATTENDANCE_WARNING_CODES = {
    WORKED_MORE_THAN_NINE_HOURS: "worked_more_than_nine_hours",
    IN_PROGRESS_OVER_NINE_HOURS: "open_session_over_9_hours",
};

const supportedStatuses = [
    "completed",
    "in_progress",
    "missed_checkout",
    "failed_checkout",
];

export const canManuallyCheckoutStaffSession = (session) => (
    Boolean(String(session?.id ?? "").trim()) &&
    session?.check_out_at === null &&
    [ "in_progress", "missed_checkout", "failed_checkout" ].includes(session?.status)
);

export const isStaffSessionManuallyClosed = (session) => (
    String((session?.check_out || session?.relCheckOutLog)?.reason || "").toUpperCase() === "MANUAL_CLOSE"
);

export const getStaffManualCheckoutActor = (log) => (
    typeof log?.detail === "string" ? log.detail.trim() : ""
);

const warningTranslationKeys = {
    [ STAFF_ATTENDANCE_WARNING_CODES.WORKED_MORE_THAN_NINE_HOURS ]:
        "STAFF_MANAGEMENT.AttendanceWarning_WorkedMoreThanNineHours",
    [ STAFF_ATTENDANCE_WARNING_CODES.IN_PROGRESS_OVER_NINE_HOURS ]:
        "STAFF_MANAGEMENT.AttendanceWarning_InProgressOverNineHours",
};

export const hasStaffAttendanceWarningCode = (warningCodes, warningCode) => (
    Array.isArray(warningCodes) && warningCodes.includes(warningCode)
);

export const getStaffAttendanceStatusIconKey = (status, warningCodes) => (
    status === "in_progress" && hasStaffAttendanceWarningCode(
        warningCodes,
        STAFF_ATTENDANCE_WARNING_CODES.IN_PROGRESS_OVER_NINE_HOURS
    ) ? "clock" : status
);

export const getStaffAttendanceWarningTranslationKey = (warningCodes = []) => {
    const warningCode = Array.isArray(warningCodes) ?
        warningCodes.find((code) => warningTranslationKeys[ code ]) :
        undefined;

    return warningCode ? warningTranslationKeys[ warningCode ] : undefined;
};

export const getStaffAttendanceSessionStatus = (session, attendanceStatus) => {
    const status = session?.status || attendanceStatus || "completed";

    return supportedStatuses.includes(status) ? status : "unknown";
};

export const getStaffAttendanceSessions = (attendanceRow) => (
    Array.isArray(attendanceRow?.sessions) ? attendanceRow.sessions : []
);

export const getStaffAttendanceSessionsCount = (attendanceRow) => {
    const rawCount = attendanceRow?.sessions_count;
    const count = rawCount === null || rawCount === undefined || rawCount === "" ?
        Number.NaN :
        Number(rawCount);

    return Number.isInteger(count) && count >= 0 ?
        count :
        getStaffAttendanceSessions(attendanceRow).length;
};

export const getStaffAttendanceFailedCheckout = (session) => {
    const failedCheckout = session?.failed_checkout;

    if (!failedCheckout)
    {
        return undefined;
    }

    return {
        attemptsCount: failedCheckout.attempts_count,
        firstAttemptAt: failedCheckout.first_attempt_at,
        lastAttemptAt: failedCheckout.last_attempt_at,
        lastDistanceFromZone: failedCheckout.last_distance_from_zone,
        lastAttempt: failedCheckout.last_attempt,
    };
};

const StaffAttendanceSessionHelper = {
    getFailedCheckout: getStaffAttendanceFailedCheckout,
    getSessions: getStaffAttendanceSessions,
    getSessionsCount: getStaffAttendanceSessionsCount,
    getSessionStatus: getStaffAttendanceSessionStatus,
    getStatusIconKey: getStaffAttendanceStatusIconKey,
    getWarningTranslationKey: getStaffAttendanceWarningTranslationKey,
    hasWarningCode: hasStaffAttendanceWarningCode,
};

export default StaffAttendanceSessionHelper;
